import { render, staticRenderFns } from "./MconEditAppr.vue?vue&type=template&id=3be3860a&scoped=true&"
import script from "./MconEditAppr.vue?vue&type=script&lang=js&"
export * from "./MconEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be3860a",
  null
  
)

export default component.exports